var _path, _path2, _path3, _rect, _path4, _rect2, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMacbook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 726 423",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M725.971 423C725.971 423 707.637 417.355 669.763 417.355L56.208 417.355C18.3345 417.355 0.000305176 423 0.000305176 423L725.971 423Z",
    fill: "url(#paint0_linear_958_275331)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7591 3.20448e-06H639.231C644.559 -0.00300781 649.67 2.11601 653.438 5.89027C657.206 9.66452 659.321 14.7844 659.318 20.122V394.317C659.321 399.655 657.206 404.775 653.438 408.549C649.67 412.323 644.559 414.442 639.231 414.439H86.7591C81.4307 414.442 76.3197 412.323 72.552 408.549C68.7842 404.775 66.6689 399.655 66.6719 394.317V20.122C66.6719 9.00891 75.6652 3.20448e-06 86.7591 3.20448e-06Z",
    fill: "url(#paint1_linear_958_275331)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4437 2.00391H638.929C643.821 2.00269 648.513 3.94884 651.972 7.41395C655.431 10.8791 657.374 15.5791 657.373 20.4795V393.285C657.374 398.185 655.431 402.885 651.972 406.35C648.513 409.815 643.821 411.762 638.929 411.76H87.4437C82.5518 411.762 77.8598 409.815 74.4007 406.35C70.9416 402.885 68.9988 398.185 69 393.285V20.4795C68.9988 15.5791 70.9416 10.8791 74.4007 7.41395C77.8598 3.94884 82.5518 2.00269 87.4437 2.00391Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 404.078,
    width: 726,
    height: 4.25506,
    fill: "url(#paint2_linear_958_275331)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 408.297C0 408.297 18.3342 418.797 56.2077 418.797H669.763C707.636 418.797 725.97 408.297 725.97 408.297H0Z",
    fill: "url(#paint3_linear_958_275331)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 294.036,
    y: 404.078,
    width: 138.168,
    height: 4.23403,
    fill: "url(#paint4_linear_958_275331)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3206 15.0273H638.679C642.743 15.0269 646.64 16.6486 649.513 19.5356C652.386 22.4226 654 26.3384 654 30.4212V399.692H72V30.4212C71.9995 26.3384 73.6135 22.4226 76.4868 19.5356C79.36 16.6486 83.2572 15.0269 87.3206 15.0273Z",
    fill: "#111111"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_958_275331",
    x1: 725.971,
    y1: 423,
    x2: 725.971,
    y2: 417.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_958_275331",
    x1: 67.2799,
    y1: 468.866,
    x2: 659.923,
    y2: 467.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#DCE2E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#ECF1F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923,
    stopColor: "#888A90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656967"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_958_275331",
    x1: 0,
    y1: 408.333,
    x2: 726,
    y2: 408.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C605D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.022,
    stopColor: "#EDF2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#D5DBDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#EEF3F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515552"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_958_275331",
    x1: 0,
    y1: 408.297,
    x2: 0,
    y2: 418.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#94969D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414542"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_958_275331",
    x1: 294.036,
    y1: 408.312,
    x2: 432.204,
    y2: 408.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#727A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046,
    stopColor: "#CBD1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488,
    stopColor: "#DEDFE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942,
    stopColor: "#CDD3D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697173"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMacbook);
export default __webpack_public_path__ + "static/media/macbook.c468135eb93998a57ab39d7b9fd0c470.svg";
export { ForwardRef as ReactComponent };